
//import {db, functions} from "@/scripts/firebase";
//import {TaskSheet } from "@/common-datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator"
import {getDoc, onSnapshot,query,Unsubscribe, where} from 'firebase/firestore'
import SequenceList from "@/components/SequenceList.vue"
import ModalStaffPlaygroundMessageList from "@/components/ModalStaffPlaygroundMessageList.vue"
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import { Playground, Playing } from "@/common-datatypes"
import { NoticeProps } from "@/scripts/datatypes"
import {getDownloadURL, updateMetadata, uploadBytes } from "firebase/storage"

@Component({
  components: {
    ModalStaffPlaygroundMessageList,
    SequenceList,
  }
})


export default class PlaygroundPlaying extends Mixins(Common) {
  audioFileName = ''
  isUploading = false

  observers: (Unsubscribe | undefined)[] = []

  playings: Playing[] = []

  isLoading = false


  thePlayground: Playground = {} as Playground

  playgroundTitle = ''

  get isDisabled(){
     if(this.playingMode.indexOf('chat') === 0){
      return ! this.playingPrompt
    }
    
    if(this.playingMode === 'transcription'){
      return ! this.audioFileName || this.isUploading
    }
    return false
  }

  clearForm () {
    this.playingPrompt = ''
    this.createObserver.reset()
  }

  showModalPlaygroundMessageList = false

  playingModes = [
    {
      value: 'chatGPT3',
      label: 'playground.mode.chatGPT3',
    },
    {
      value: 'chatGPT4',
      label: 'playground.mode.chatGPT4',
    },
    {
      value: 'transcription',
      label: 'playground.mode.transcription',
    },
  ]

  inputFiles: FileList | null = null

  async uploadAudioFile(e?: Event){
    if(e && e.target){
      const target = e.target as HTMLInputElement
      if(target.files !== null){
        this.inputFiles = target.files
      }
    }

    if(this.inputFiles === null){
      return
    }

    this.$store.commit('setLoading',true)
    this.isUploading = true
    
    const file = this.inputFiles[0]
    this.audioFileName = file.name
    try{   
      const profileRef = this.$getUserAudioRef(this.queryPlaygroundId)

      await uploadBytes(profileRef, file)

    }catch(error){
      console.table(error)
      //const errorCode = this.$getErrorCode(error)

      this.notice = {
				message: 'profile.uploadError',
				isShow: true,
				type: {'is-danger': true}
      }


    }finally{
      this.$store.commit('setLoading',false)
      this.isUploading = false
    }
  }

  updatePlayingProps(docId: string,searchResultsNum: number){
    const hidden = this.playingsProps[docId].hidden
    if(searchResultsNum > 0 && hidden){
      this.playingsProps[docId].hidden = false
      this.searchResultsNum = this.searchResultsNum + 1
    }
  }

  getModeLabel(mode: string){
    const modeObj = this.playingModes.find((modeObj) => modeObj.value === mode)
    if(modeObj){
      return modeObj.label
    }
    return ''
  }

  playingMode = this.playingModes[0].value
  playingPrompt = ''


  //showModalTaskMessenger = false

  modalPlaygroundProps = {
    isLoading: false,
    errorMessage: '',
    //confirmText: 'event.add',
    thePlayground: this.thePlayground
  }

  playingsProps = {} as {[key: string]: {hidden: boolean}}
	notice: NoticeProps = {} 
 
  get searchObserver(){
    return this.$refs.searchPlayingFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get createObserver(){
    return this.$refs.createPlayingValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get queryPlaygroundId(){
    return this.$route.params.playgroundId as string
  }

  @Watch('queryPlaygroundId',{immediate: true})
  async changeQueryPlaygroundId(playgroundId: string){
    if(typeof playgroundId === 'string'){
      try{
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const playgroundDoc = await getDoc(this.$getPlaygroundDocRef(playgroundId))

        if(playgroundDoc.exists()){
          this.thePlayground = playgroundDoc.data() as Playground

          if(this.thePlayground.title){
            this.playgroundTitle = this.thePlayground.title
          
            // where('playgroundId','==',this.queryPlaygroundId)
            const queryPlayings = query(this.$getPlayingColRef(),where('playgroundId','==',this.queryPlaygroundId))

            this.observers.push(onSnapshot(queryPlayings,(snapshot) => {
              snapshot.docs.forEach((doc) => {
                const row = doc.data() as Playing

                const findIndex = this.playings.findIndex((playing) => {return playing.docId === doc.id})
          
                const deleteCount = (findIndex === -1 ? 0 : 1)
                this.playings.splice(findIndex,deleteCount,row)

                if(deleteCount === 0){
                  this.playingsProps = {
                    ...this.playingsProps,
                    [doc.id]: {hidden: false}
                  }
                }

                this.playings.sort((a,b) => {
                  if(a.updateTime && b.updateTime){
                    return b.updateTime.getTime() - a.updateTime.getTime()
                  }
                  return 0
                })
              })
            }))      
   
          }
        }
      }catch(error){
        console.log(error)
      }finally{
        this.$store.commit("setLoading",false);
        this.isLoading = false
      }
    }
  }


  search = ''

  searchResult = ''

  searchResultsNum = 0

  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0

    this.playings.forEach((playing) => {
      if(playing.docId){
        if(val.length === 0){
          this.playingsProps[playing.docId] = {hidden: false}
          return
        }

        if(playing.prompt && playing.prompt.indexOf(val) > -1){
          this.playingsProps[playing.docId] = {hidden: false}
          searchResultsNum ++
          return
        }

        this.playingsProps = {
          ...this.playingsProps,
          [playing.docId]: {hidden: true}
        }
      }
    })
    this.searchResultsNum = searchResultsNum
  }

@Watch('searchResultsNum')
updateSearchResult(searchResultsNum: number){
  if(this.search && searchResultsNum === 0){
    this.searchResult = this.$t('playground.notFound') as string
  }else{
    this.searchResult = ''
  }
}
  async created(){
    console.trace('created')
  }

  public async createPlaying() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.createObserver.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const data: Playing = {
        mode: this.playingMode,
        prompt: this.playingPrompt,
        playgroundId: this.queryPlaygroundId,
      }

      const doc = await this.$createDoc(this.$getPlayingColRef(),data)

      if(doc){
        if(this.playingMode === 'transcription'){
          const audioRef = this.$getUserAudioRef(this.queryPlaygroundId)

          try{
            await getDownloadURL(audioRef)
          }catch(e){
            await this.uploadAudioFile()
          }

          await updateMetadata(audioRef, {
            customMetadata: {
              playingId: doc.id,
            }
          })
        }
      }

      this.notice = {
        message: this.$t('playground.running') as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }

      //this.playgroundTitle = ''
      this.createObserver.reset()

    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  showMessages(){
    this.showModalPlaygroundMessageList = true
    this.modalPlaygroundProps = {
      ...this.modalPlaygroundProps,
      thePlayground: this.thePlayground
    }
  }


  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
